export default class Queue {
  static queue = []
  static working = false

  static enqueue(promise) {
    return new Promise((resolve, reject) => {
      this.queue.push({
        promise,
        resolve,
        reject
      })
      this.dequeue()
    })
  }

  static dequeue() {
    if (this.working) {
      return false
    }
    const item = this.queue.shift()
    if (!item) {
      return false
    }
    try {
      this.working = true
      item.promise()
        .then((value) => {
          this.working = false
          item.resolve(value)
          this.dequeue()
        })
        .catch(err => {
          this.working = false
          item.reject(err)
          this.dequeue()
        })
    } catch (err) {
      this.working = false
      item.reject(err)
      this.dequeue()
    }
    return true
  }
}